import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import tenantReducer from './slices/tenantSlice'
import uiReducer from './slices/uiSlice'
import farmsReducer from './slices/farmsSlice'
import productsReducer from './slices/productsSlice'
import ordersReducer from './slices/ordersSlice'
import cartReducer from './slices/cartSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    tenant: tenantReducer,
    ui: uiReducer,
    farms: farmsReducer,
    products: productsReducer,
    orders: ordersReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
